export default class Jogo {
    constructor(nome, tipo, jogadoresPorTime, tempoDeJogo, pontosParaAcabar, dadosIndividuais = false, corTime1 = '#000000', corTime2 = '#8cff53', maxVictories = 0) {
        this.nome = nome;
        this.tipo = tipo;
        this.jogadoresPorTime = jogadoresPorTime;
        this.tempoDeJogo = tempoDeJogo;
        this.pontosParaAcabar = pontosParaAcabar;
        this.dadosIndividuais = dadosIndividuais;
        this.corTime1 = corTime1;
        this.corTime2 = corTime2;
        this.maxVictories = maxVictories;
    }
}